module.exports = __webpack_public_path__ + "img/logoHTML.a21efbce.svg";